import "alpinejs";
import Alpine from "alpinejs";

window.Alpine = Alpine;

document.addEventListener("alpine:init", () => {
    Alpine.data("siteSection", () => {
    });
});

Alpine.start();

jQuery(function ($) {
    $(".ex-co-title").on("click", function (e) {
        e.preventDefault();
        console.log("click");
        const $this = $(this);
        const currentArrow = $this.find('.up-side-down');
        const parentWidget = $this.closest(".ex-co-sidebar");
        const currentContent = parentWidget.find(".ex-co-content");
        const parentSidebar = $this.closest(".ex-co-container");
        const contents = parentSidebar.find(".ex-co-content");
        const allArrow = parentSidebar.find('.up-side-down');

        contents.each(function () {
            if (!$(this).is(currentContent)) {
                $(this).css('display', 'none');
            }
        });
        allArrow.each(function () {
            if (!$(this).is(currentArrow)) {
                $(this).css({
                    'transform': 'rotate(0deg)',
                    'transition': 'transform 0.3s ease'
                });
            }
        });
        if (currentContent.css('display') === 'none') {
            currentContent.fadeIn("fast");
            currentArrow.css({
                'transform': 'rotate(180deg)',
                'transition': 'transform 0.3s ease'
            });
        } else {
            currentContent.fadeOut("fast");
            currentArrow.css({
                'transform': 'rotate(0deg)',
                'transition': 'transform 0.3s ease'
            });
        }
    });
});